import type { TipTapBlockEditorProps } from "@circle-react-uikit/TipTapBlockEditor";
import { TipTapBlockEditor } from "@circle-react-uikit/TipTapBlockEditor";
import type { JSONContent } from "@tiptap/react";
import { isFunction, noop } from "lodash";
import { Controller, useFormContext } from "react-hook-form";

export interface FormTipTapBlockEditorProps extends TipTapBlockEditorProps {
  name: string;
  onChangeCallback?: (value: JSONContent) => void;
}

export const FormTipTapBlockEditor = ({
  name,
  onChangeCallback = noop,
  ...passThroughProps
}: FormTipTapBlockEditorProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <TipTapBlockEditor
          value={value}
          onChange={value => {
            isFunction(onChangeCallback) && onChangeCallback(value);
            onChange(value);
          }}
          {...passThroughProps}
        />
      )}
    />
  );
};
